/**
 * Fichas SEO públicas /:slug (ej. /tokio, /kioto).
 * La preview sigue en /preview/prebuilt/:guideId (no se toca).
 */

export const GUIDE_LANDINGS = {
	kioto: {
		guideId: "kioto",
		slug: "kioto",
		name: "Kioto",
		widePromo: true,
		ogImage: "/og-kioto.png",
		country: "Japón",
		chip: "Japón · Ciudad",
		days: 4,
		h1: "Guía de Kioto: itinerario de 4 días",
		lead: "Templos, santuarios, Gion y rutas por zonas. Una guía de 4 días para descubrir Kioto sin cruzar la ciudad dos veces el mismo día.",
		seoTitle: "Guía de Kioto 4 días",
		seoDescription:
			"Guía de Kioto 4 días: Kiyomizudera, Gion, Pabellón Dorado, Arashiyama, Fushimi Inari, Nara, transporte y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Kioto se disfruta a pie y por barrios. El plan ya está hecho para que no dejes Fushimi Inari para el último hueco libre.",
		ctaTitle: "Guarda tu guía de Kioto",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["4 días", "Gion", "Arashiyama", "Fushimi Inari"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "Visa y entrada a Japón",
				text: "Con pasaporte español no necesitas visado hasta 90 días. Si tu pasaporte es de otro país, revisa si necesitas visado.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de imprescindibles de Kioto, como Kinkaku-ji, Fushimi Inari o Kiyomizu-dera, se visitan sin reserva. Sin embargo, algunos lugares sí requieren o recomiendan reservar, como Saiho-ji (Templo del Musgo) o Katsura Imperial Villa. Las experiencias populares, como ceremonias del té, también pueden agotarse en temporada alta.",
			},
			{
				icon: "tip",
				title: "Dinero y propinas",
				text: "En Japón no se deja propina. Lleva algo de efectivo: aunque la tarjeta está muy extendida, algunos pequeños comercios y negocios tradicionales todavía aceptan solo efectivo.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Las mejores zonas para alojarse son Kyoto Station, si priorizas el transporte y las excursiones, Kawaramachi, por su ubicación céntrica y su cercanía a Nishiki y Gion, y Gion/Higashiyama, si buscas un ambiente más tradicional y estar cerca de templos y calles históricas.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo A",
				text: "Si vienes de Europa, necesitarás adaptador. El voltaje en Japón es de 100 V.",
			},
			{
				icon: "card",
				title: "ICOCA o Suica",
				text: "Puedes usarlas para pagar bus, metro y muchos trenes JR. En Kioto, los buses son especialmente útiles para desplazarte entre las distintas zonas y templos.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la ciudad",
		neighborhoods: [
			{
				name: "Higashiyama y Gion",
				text: "Kiyomizu-dera, Yasaka, callejuelas tradicionales y el barrio de Gion. El Kioto más clásico.",
			},
			{
				name: "Noroeste de Kioto",
				text: "Kinkaku-ji, Ryoan-ji y otros templos. Una zona más tranquila y alejada del centro.",
			},
			{
				name: "Arashiyama",
				text: "Bosque de bambú, Tenryu-ji y paseo junto al río. Está al oeste y conviene agrupar las visitas de esta zona.",
			},
			{
				name: "Fushimi",
				text: "Fushimi Inari y sus miles de torii, al sur de la ciudad. Ideal ir temprano para evitar las horas de más gente.",
			},
			{
				name: "Centro de Kioto",
				text: "Nishiki Market, Kawaramachi, Pontocho y zona comercial. Perfecto para pasear, comer y salir por la tarde-noche.",
			},
			{
				name: "Kyoto Station",
				text: "Principal nudo de transporte de la ciudad y una buena base para moverte por Kioto o hacer excursiones.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "ICOCA o Suica",
					text: "Úsalas para pagar bus, metro y muchos trenes. Funcionan en Kioto y en gran parte de Japón.",
				},
				{
					icon: "transit",
					title: "Bus de Kioto",
					text: "Muy útil para llegar a muchos templos y zonas sin conexión directa de metro o tren. Comprueba siempre el número y el sentido de la línea.",
				},
				{
					icon: "direction",
					title: "Este, norte y oeste",
					text: "Higashiyama queda al este, Kinkaku-ji al noroeste y Arashiyama al oeste. Agrupar las visitas por zonas te ahorrará bastante tiempo.",
				},
				{
					icon: "airport",
					title: "Desde Osaka o Kansai",
					text: "Desde Osaka puedes llegar fácilmente en JR o tren privado. Desde el aeropuerto de Kansai, el HARUKA es una de las opciones más cómodas y directas hasta Kyoto Station.",
				},
			],
		},
		itineraryTitle: "Itinerario de 4 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Kiyomizudera y Gion",
			},
			{
				day: 2,
				title: "Pabellón Dorado y el norte de Kioto",
			},
			{
				day: 3,
				title: "Arashiyama",
			},
			{
				day: 4,
				title: "Fushimi Inari y Nara",
			},
			{
				day: 5,
				title: "Extra: Este de Kioto",
			},
		],
		hub: [
			{
				title: "Organiza tu ruta",
				text: "Arma un recorrido por Kioto y elige los sitios que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Japón con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/kioto",
				icon: "preview",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Cuatro días por zonas, para no cruzar Kioto tres veces.",
			},
			{
				icon: "temple",
				title: "Templos y santuarios",
				text: "Kiyomizu, Kinkaku-ji, Fushimi Inari y el ritmo de la ciudad.",
			},
			{
				icon: "transit",
				title: "Mapas y transporte",
				text: "Bus, ICOCA y cómo llegar desde Osaka o Kansai.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "nightlife",
				title: "Gion y calles con alma",
				text: "El barrio de las geishas y las callejuelas de Higashiyama.",
			},
			{
				icon: "park",
				title: "Arashiyama y naturaleza",
				text: "Bambú, río y el Kioto más verde al oeste.",
			},
		],
		related: ["tokio", "osaka", "seul"],
	},
	tokio: {
		guideId: "tokio",
		slug: "tokio",
		name: "Tokio",
		widePromo: true,
		ogImage: "/og-tokio.png",
		country: "Japón",
		chip: "Japón · Ciudad",
		days: 6,
		h1: "Guía de Tokio: itinerario de 6 días",
		lead: "Shibuya, Asakusa, Shinjuku y muchos más. Una guía de 6 días para no perderte en la capital.",
		seoTitle: "Guía de Tokio 6 días",
		seoDescription:
			"Guía de Tokio 6 días: Asakusa, Shibuya, Kamakura, Ginza, Shinjuku, Suica, aeropuertos y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Tokio es inmensa. Aquí ya está partida por zonas para que no cruces la ciudad tres veces el mismo día.",
		ctaTitle: "Guarda tu guía de Tokio",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["6 días", "Shibuya", "Asakusa", "Shinjuku"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "Visa y entrada a Japón",
				text: "Con pasaporte español no necesitas visado hasta 90 días. Si tu pasaporte es de otro país, revisa si necesitas visado.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de lugares de Tokio se visitan sin reserva. Conviene reservar con antelación solo algunas atracciones con plazas limitadas, como teamLab, Shibuya Sky o el Museo Ghibli.",
			},
			{
				icon: "tip",
				title: "Dinero y propinas",
				text: "En Japón no se deja propina. Lleva algo de efectivo: aunque la tarjeta está muy extendida, algunos pequeños comercios y negocios tradicionales todavía aceptan solo efectivo.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Lo más práctico es alojarse cerca de una estación de la línea Yamanote, que conecta muchas de las principales zonas de Tokio. Shinjuku y Shibuya son ideales si buscas ambiente y buenas conexiones, Ueno es una opción muy cómoda y bien comunicada, y Tokyo Station/Ginza funciona muy bien si priorizas transporte y excursiones. Asakusa es una buena alternativa si prefieres una zona más tradicional, aunque queda fuera de la Yamanote.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo A",
				text: "Si vienes de Europa, necesitarás adaptador. El voltaje en Japón es de 100 V.",
			},
			{
				icon: "card",
				title: "Suica o Pasmo",
				text: "El metro y los trenes JR son la mejor forma de moverse por Tokio. Con una Suica o PASMO puedes pagar fácilmente ambos sistemas y muchos autobuses.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la ciudad",
		neighborhoods: [
			{
				name: "Asakusa, Ueno y Akihabara",
				text: "Senso-ji, parque de Ueno y Akihabara. Una mezcla del Tokio tradicional, cultural y otaku.",
			},
			{
				name: "Harajuku y Shibuya",
				text: "Meiji Jingu, Takeshita-dori, Omotesando y el cruce de Shibuya. Una de las zonas más animadas de Tokio.",
			},
			{
				name: "Shinjuku",
				text: "Rascacielos, miradores, Kabukicho y muchísimo ambiente. Ideal para la tarde y la noche.",
			},
			{
				name: "Ginza y Tokyo Station",
				text: "Compras, Marunouchi, Palacio Imperial y la zona de Tokyo Station. El Tokio más elegante y monumental.",
			},
			{
				name: "Odaiba y bahía de Tokio",
				text: "Zona moderna junto a la bahía, con centros comerciales, vistas del skyline y algunas de las atracciones más conocidas de la ciudad.",
			},
			{
				name: "Roppongi y Azabudai",
				text: "Miradores, museos, arquitectura moderna y nuevos complejos como Azabudai Hills.",
			},
			{
				name: "Ikebukuro",
				text: "Compras, ocio, anime y grandes complejos como Sunshine City.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "Suica o Pasmo",
					text: "Úsalas para pagar metro, JR y muchos autobuses. Funcionan en Tokio y en gran parte de Japón.",
				},
				{
					icon: "transit",
					title: "Metro y JR",
					text: "Son redes distintas, pero ambas se pueden pagar con Suica o PASMO. Comprueba siempre la línea, la dirección y el destino antes de subir.",
				},
				{
					icon: "direction",
					title: "Yamanote",
					text: "La línea circular que conecta zonas clave como Shinjuku, Shibuya, Ueno, Tokyo Station e Ikebukuro. Muy útil para orientarte por la ciudad.",
				},
				{
					icon: "airport",
					title: "Desde Narita o Haneda",
					text: "Desde Narita, las opciones más cómodas son el Narita Express y el Keisei Skyliner. Desde Haneda, el Tokyo Monorail y la línea Keikyu conectan fácilmente con el centro.",
				},
			],
		},
		itineraryTitle: "Itinerario de 6 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Asakusa, Ueno y Akihabara",
			},
			{
				day: 2,
				title: "Harajuku y Shibuya",
			},
			{
				day: 3,
				title: "Excursión a Kamakura",
			},
			{
				day: 4,
				title: "Palacio Imperial, Ginza y Odaiba",
			},
			{
				day: 5,
				title: "Shinjuku y Torre de Tokio",
			},
			{
				day: 6,
				title: "Día libre o excursión",
			},
		],
		hub: [
			{
				title: "Organiza tu ruta",
				text: "Arma un recorrido por Tokio y elige los sitios que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Japón con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/tokio",
				icon: "preview",
			},
			{
				title: "Ruta interactiva",
				text: "Explora Tokio día a día en el mapa y abre cada lugar de la ruta.",
				to: "/rutas/tokio",
				icon: "map",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Seis días por zonas, para no cruzar Tokio tres veces.",
			},
			{
				icon: "skyline",
				title: "Barrios e iconos",
				text: "Shibuya, Shinjuku, Asakusa y el contraste entre neón y templos.",
			},
			{
				icon: "transit",
				title: "Mapas y transporte",
				text: "Suica, Yamanote y cómo llegar desde Narita o Haneda.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "food",
				title: "Comer bien sin perderse",
				text: "Ramen, izakayas y mercados: una base para no improvisar cada comida.",
			},
			{
				icon: "store",
				title: "Compras y cultura pop",
				text: "Harajuku, Akihabara y las tiendas que sí merecen una parada.",
			},
		],
		related: ["kioto", "osaka", "seul"],
	},
	osaka: {
		guideId: "osaka",
		slug: "osaka",
		name: "Osaka",
		widePromo: true,
		ogImage: "/og-osaka.png",
		country: "Japón",
		chip: "Japón · Ciudad",
		days: 3,
		h1: "Guía de Osaka: itinerario de 3 días",
		lead: "Dotonbori, Shinsekai, el castillo y muchos más. Una guía de 3 días para no perderte en Osaka.",
		seoTitle: "Guía de Osaka 3 días",
		seoDescription:
			"Guía de Osaka 3 días: Dotonbori, castillo, Shinsekai, ICOCA, aeropuerto de Kansai, comida callejera y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Osaka se come y se camina. El plan ya está hecho para que no dejes el castillo para el último día.",
		ctaTitle: "Guarda tu guía de Osaka",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["3 días", "Dotonbori", "Shinsekai", "Namba"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "Visa y entrada a Japón",
				text: "Con pasaporte español no necesitas visado hasta 90 días. Si tu pasaporte es de otro país, revisa si necesitas visado.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de lugares de Osaka se visitan sin reserva. Conviene reservar con antelación Universal Studios Japan. Para miradores como Umeda Sky Building, comprar la entrada online puede ayudarte a ahorrar tiempo, pero no suele ser imprescindible.",
			},
			{
				icon: "tip",
				title: "Dinero y propinas",
				text: "En Japón no se deja propina. Lleva algo de efectivo: aunque la tarjeta está muy extendida, algunos pequeños comercios y negocios tradicionales todavía aceptan solo efectivo.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Las zonas más recomendables son Namba, si quieres estar cerca de Dotonbori, restaurantes y ambiente, Umeda, si priorizas conexiones de tren y excursiones, y Shinsaibashi, si buscas una zona céntrica con tiendas y fácil acceso a Namba. Para una primera visita, Namba suele ser una de las mejores opciones.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo A",
				text: "Si vienes de Europa, necesitarás adaptador. El voltaje en Japón es de 100 V.",
			},
			{
				icon: "card",
				title: "ICOCA o Suica",
				text: "El metro y los trenes JR son la mejor forma de moverse por Osaka. Con una ICOCA o Suica puedes pagar fácilmente ambos sistemas y muchos autobuses.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la ciudad",
		neighborhoods: [
			{
				name: "Namba y Dotonbori",
				text: "La zona más animada de Osaka, con el famoso Glico Man, muchos restaurantes, comida callejera y mucho ambiente, especialmente por la tarde y la noche.",
			},
			{
				name: "Shinsaibashi y Amerikamura",
				text: "Una de las mejores zonas para ir de compras, descubrir tiendas diferentes y disfrutar de un ambiente joven y urbano, muy cerca de Namba y Dotonbori.",
			},
			{
				name: "Shinsekai y Tennoji",
				text: "Una zona famosa por la torre Tsutenkaku, el ambiente retro y el kushikatsu. En Tennoji encontrarás además parques, templos y zonas más tranquilas.",
			},
			{
				name: "Castillo de Osaka",
				text: "Una de las visitas históricas más conocidas de la ciudad, rodeada por un gran parque que merece la pena recorrer con calma.",
			},
			{
				name: "Umeda",
				text: "La zona moderna del norte de Osaka, con grandes centros comerciales, rascacielos y el famoso Umeda Sky Building. También es uno de los principales puntos de transporte de la ciudad.",
			},
			{
				name: "Osaka Bay",
				text: "La zona de ocio junto a la bahía, donde se encuentran Universal Studios Japan, el Aquarium Kaiyukan y Tempozan.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "ICOCA o Suica",
					text: "Úsalas para pagar metro, JR y muchos autobuses. Funcionan en Osaka y en gran parte de Japón.",
				},
				{
					icon: "transit",
					title: "Metro y JR",
					text: "Son redes distintas, pero ambas se pueden pagar con ICOCA o Suica. Comprueba siempre la línea, la dirección y el destino antes de subir.",
				},
				{
					icon: "direction",
					title: "Norte y sur",
					text: "Umeda queda al norte y Namba al sur. Agrupar las visitas por zonas te ahorrará bastante tiempo.",
				},
				{
					icon: "airport",
					title: "Desde Kansai (KIX)",
					text: "Desde el aeropuerto de Kansai, el HARUKA llega a Shin-Osaka y Osaka Station. El Nankai Rapi:t llega directo a Namba.",
				},
			],
		},
		itineraryTitle: "Itinerario de 3 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Castillo y Shinsekai",
			},
			{
				day: 2,
				title: "Centro de Osaka y Dotonbori",
			},
			{
				day: 3,
				title: "Universal Studios Japan",
			},
		],
		hub: [
			{
				title: "Organiza tu ruta",
				text: "Arma un recorrido por Osaka y elige los sitios que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Japón con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/osaka",
				icon: "preview",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Tres días por zonas, para no cruzar la ciudad tres veces.",
			},
			{
				icon: "food",
				title: "Capital de la comida",
				text: "Takoyaki, okonomiyaki y el circuito de Dotonbori sin ir a ciegas.",
			},
			{
				icon: "transit",
				title: "Mapas y transporte",
				text: "ICOCA, metro y cómo llegar desde Kansai sin pagar de más.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "temple",
				title: "Castillo e iconos",
				text: "Osaka-jo, Tsutenkaku y el skyline de Umeda.",
			},
			{
				icon: "nightlife",
				title: "Noches con neón",
				text: "Namba, Shinsekai y el ambiente más desenfadado de Japón.",
			},
		],
		related: ["kioto", "tokio", "seul"],
	},
	"nueva-york": {
		guideId: "ny",
		slug: "nueva-york",
		name: "Nueva York",
		widePromo: true,
		ogImage: "/og-nueva-york.png",
		country: "Estados Unidos",
		chip: "USA · Ciudad",
		days: 7,
		h1: "Guía de Nueva York: itinerario de 7 días",
		lead: "Times Square, Central Park, Brooklyn y muchos más. Una guía de 7 días para no perderte en Nueva York.",
		seoTitle: "Guía de Nueva York 7 días",
		seoDescription:
			"Guía de Nueva York 7 días: itinerario por barrios, metro y OMNY, aeropuertos, qué reservar y tips de propina, ESTA y enchufes. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"NY se come a quien improvisa. Aquí los días van por barrios para no cruzar la isla tres veces.",
		ctaTitle: "Guarda tu guía de Nueva York",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["7 días", "Midtown", "Brooklyn", "Central Park"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "ESTA o visado",
				text: "Con pasaporte español necesitas ESTA (se pide online). Si tu pasaporte es de otro país, revisa si necesitas ESTA o visado.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de lugares de Nueva York se pueden visitar sin reserva. Conviene reservar con antelación la Estatua de la Libertad y los miradores más populares, y comprar antes las entradas de Broadway si quieres ver un espectáculo concreto.",
			},
			{
				icon: "tip",
				title: "Propina e impuestos",
				text: "En restaurantes con servicio en mesa se suele dejar entre un 18 % y un 20 % de propina. El precio mostrado normalmente no incluye impuestos, que en Nueva York añaden alrededor de un 9 % al total.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Las zonas más recomendables son Midtown, si quieres estar cerca de muchas de las principales atracciones y moverte fácilmente, Chelsea o Flatiron, si buscas una zona céntrica pero algo más tranquila, y Upper West Side, si prefieres un ambiente más residencial junto a Central Park. Para una primera visita, alojarse en Manhattan suele ser lo más práctico.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo A/B",
				text: "Si vienes de Europa, necesitarás adaptador. El voltaje en Estados Unidos es de 120 V.",
			},
			{
				icon: "omny",
				title: "OMNY",
				text: "El metro es la mejor forma de moverse por Nueva York. Paga directamente con tarjeta contactless o móvil en el torno. Después de 12 viajes pagados en una semana, los siguientes son gratis.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la ciudad",
		neighborhoods: [
			{
				name: "Midtown",
				text: "La zona más icónica de Manhattan con Times Square, Rockefeller Center, Quinta Avenida, Bryant Park y el Empire State Building.",
			},
			{
				name: "Lower Manhattan",
				text: "La zona financiera e histórica con Wall Street, World Trade Center, One World Observatory, Battery Park y acceso a la Estatua de la Libertad.",
			},
			{
				name: "SoHo, Chinatown y Little Italy",
				text: "Una zona ideal para pasear, descubrir tiendas, comer y recorrer algunos de los barrios con más personalidad del Downtown.",
			},
			{
				name: "Greenwich Village y West Village",
				text: "Calles con encanto, cafés, casas típicas, Washington Square Park y un ambiente más tranquilo y local.",
			},
			{
				name: "Chelsea y Hudson Yards",
				text: "High Line, Chelsea Market, The Vessel, Edge y una de las zonas más modernas del West Side.",
			},
			{
				name: "Central Park y Upper Manhattan",
				text: "Central Park, el Metropolitan Museum, Upper East Side y Upper West Side. Una zona más tranquila y residencial.",
			},
			{
				name: "Brooklyn Heights y DUMBO",
				text: "El puente de Brooklyn, calles con encanto y algunas de las mejores vistas del skyline de Manhattan.",
			},
			{
				name: "Williamsburg",
				text: "Restaurantes, tiendas, cafés y un ambiente más local y alternativo junto al East River.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "omny",
					title: "OMNY",
					text: "Paga el metro y los autobuses locales directamente con tarjeta contactless o móvil. Al alcanzar el límite semanal de viajes pagados, los siguientes son gratis durante ese periodo.",
				},
				{
					icon: "direction",
					title: "Uptown y Downtown",
					text: "Uptown indica dirección norte y Downtown dirección sur. En algunas estaciones, los accesos están separados según el sentido, así que conviene comprobarlo antes de entrar.",
				},
				{
					icon: "transit",
					title: "Local y express",
					text: "Los trenes express se saltan algunas paradas. Comprueba siempre la letra o el número de la línea y si el tren es local o express antes de subir.",
				},
				{
					icon: "airport",
					title: "Desde el aeropuerto",
					text: "Desde JFK, AirTrain + metro es una de las opciones más económicas. Desde Newark, AirTrain + NJ Transit conecta con Manhattan. Desde LaGuardia, lo habitual es combinar bus y metro o utilizar taxi.",
				},
			],
		},
		itineraryTitle: "Itinerario de 7 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Midtown Manhattan",
			},
			{
				day: 2,
				title: "Lower Manhattan & Estatua de la Libertad",
			},
			{
				day: 3,
				title: "Brooklyn, Chinatown & Little Italy",
			},
			{
				day: 4,
				title: "Central Park y Upper Manhattan",
			},
			{
				day: 5,
				title: "Del Empire State al SoHo",
			},
			{
				day: 6,
				title: "Hudson Yards y Chelsea",
			},
			{
				day: 7,
				title: "Día libre o excursión",
			},
		],
		hub: [
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/ny",
				icon: "preview",
			},
			{
				title: "Organiza tu ruta",
				text: "Crea tu recorrido por Nueva York y elige los lugares que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Nueva York con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Siete días agrupados por isla y barrio, para no cruzar Manhattan tres veces.",
			},
			{
				icon: "skyline",
				title: "Lugares e iconos",
				text: "Midtown, Downtown, Brooklyn y las vistas que sí merecen la cola.",
			},
			{
				icon: "transit",
				title: "Mapas y subway",
				text: "Metrocard, líneas útiles y cómo no perder 40 minutos en un transbordo.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "museum",
				title: "Museos sin empacho",
				text: "Una selección para no intentar el Met, MoMA y el Guggenheim el mismo día.",
			},
			{
				icon: "park",
				title: "Barrios y parques",
				text: "Brooklyn, Village, Central Park y el ritmo de cada zona.",
			},
		],
		related: ["san-francisco", "londres", "paris"],
	},
	"san-francisco": {
		guideId: "sanFrancisco",
		slug: "san-francisco",
		name: "San Francisco",
		widePromo: true,
		ogImage: "/og-san-francisco.png",
		country: "Estados Unidos",
		chip: "USA · California",
		days: 3,
		h1: "Guía de San Francisco: itinerario de 3 días",
		lead: "Golden Gate, Alcatraz, Chinatown y muchos más. Una guía de 3 días para no perderte en San Francisco.",
		seoTitle: "Guía de San Francisco 3 días",
		seoDescription:
			"Guía de San Francisco 3 días: Golden Gate, Alcatraz, Downtown, Cable Cars, ESTA y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Tres días dan de sí si no los gastas en la misma colina dos veces. El plan ya está por zonas.",
		ctaTitle: "Guarda tu guía de San Francisco",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["3 días", "Golden Gate", "Alcatraz", "Chinatown"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "ESTA o visado",
				text: "Con pasaporte español necesitas ESTA (se pide online). Si tu pasaporte es de otro país, revisa si necesitas ESTA o visado.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de lugares de San Francisco se visitan sin reserva. Conviene reservar Alcatraz con antelación, ya que las entradas incluyen el ferry y pueden agotarse, especialmente en temporada alta.",
			},
			{
				icon: "tip",
				title: "Propina e impuestos",
				text: "En restaurantes con servicio en mesa se suele dejar entre un 18 % y un 20 % de propina. El precio mostrado normalmente no incluye impuestos.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Las zonas más recomendables son Union Square, si quieres una ubicación céntrica y buenas conexiones, Fisherman’s Wharf, si prefieres estar cerca del paseo marítimo y de algunas de las atracciones más conocidas, Nob Hill, si buscas una zona más tranquila aunque con bastante pendiente, y Marina District, si te apetece cerca de la bahía.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo A/B",
				text: "Si vienes de Europa, necesitarás adaptador. El voltaje en Estados Unidos es de 120 V.",
			},
			{
				icon: "card",
				title: "Transporte público",
				text: "Muni es la forma más práctica de moverse por la ciudad y BART resulta útil para trayectos más largos. Con Clipper puedes pagar autobuses, Muni Metro, cable cars y BART desde una tarjeta física o el móvil.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la ciudad",
		neighborhoods: [
			{
				name: "Union Square y Downtown",
				text: "Una de las zonas más céntricas de San Francisco con muchos hoteles, tiendas y buenas conexiones de transporte.",
			},
			{
				name: "Embarcadero y Fisherman’s Wharf",
				text: "La zona más turística junto a la bahía con el Ferry Building, Pier 39 y el embarque hacia Alcatraz.",
			},
			{
				name: "Golden Gate y Presidio",
				text: "Una de las visitas imprescindibles de la ciudad con el Golden Gate Bridge, Crissy Field y algunos de los mejores miradores.",
			},
			{
				name: "Chinatown y North Beach",
				text: "Dos barrios con mucho ambiente, uno marcado por la cultura china y el otro por su tradición italiana, cafés y restaurantes.",
			},
			{
				name: "Mission District",
				text: "Un barrio conocido por sus murales, taquerías y Dolores Park con un ambiente más local y alternativo.",
			},
			{
				name: "Castro y Haight-Ashbury",
				text: "Dos zonas muy ligadas a la historia cultural de San Francisco y con una personalidad muy diferente al centro.",
			},
			{
				name: "Alamo Square y Hayes Valley",
				text: "Una zona agradable para pasear, ver las Painted Ladies y descubrir calles residenciales, tiendas y restaurantes.",
			},
			{
				name: "Marina y Palace of Fine Arts",
				text: "Una de las zonas más agradables junto a la bahía con el Palace of Fine Arts y buenas vistas hacia el Golden Gate.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "Clipper",
					text: "Usa Clipper para pagar Muni, BART, Cable Cars y algunos ferris. Puedes llevarla en tarjeta física o en el móvil.",
				},
				{
					icon: "transit",
					title: "Muni y Cable Cars",
					text: "Muni cubre gran parte de la ciudad con autobuses y Muni Metro. Los Cable Cars son más lentos, pero forman parte de la experiencia de visitar San Francisco.",
				},
				{
					icon: "direction",
					title: "Cuestas",
					text: "San Francisco tiene muchas pendientes. Agrupar las visitas por zonas te ayudará a evitar trayectos innecesarios y demasiadas subidas y bajadas.",
				},
				{
					icon: "airport",
					title: "Desde SFO u Oakland",
					text: "Desde SFO, BART conecta directamente con el centro. Desde Oakland, puedes llegar en BART haciendo conexión desde el aeropuerto. Taxi o Uber pueden ser más cómodos si viajas con equipaje.",
				},
			],
		},
		itineraryTitle: "Itinerario de 3 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Downtown + Waterfront",
			},
			{
				day: 2,
				title: "Golden Gate + Alcatraz",
			},
			{
				day: 3,
				title: "Barrios con personalidad",
			},
		],
		hub: [
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/sanFrancisco",
				icon: "preview",
			},
			{
				title: "Organiza tu ruta",
				text: "Crea tu recorrido por San Francisco y elige los lugares que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de San Francisco con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Tres días por zonas, para no subir la misma colina dos veces.",
			},
			{
				icon: "skyline",
				title: "Iconos que sí merecen",
				text: "Golden Gate, Alcatraz y las vistas sin hacer de turista todo el día.",
			},
			{
				icon: "transit",
				title: "Mapas y transporte",
				text: "Clipper, Cable Cars y cómo llegar desde SFO.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "nightlife",
				title: "Barrios con personalidad",
				text: "Mission, Castro, Chinatown y Haight: cada uno un viaje distinto.",
			},
			{
				icon: "food",
				title: "Comer en la bahía",
				text: "Mercados, brunch y marisco sin caer solo en Fisherman’s Wharf.",
			},
		],
		related: ["nueva-york", "londres", "paris"],
	},
	londres: {
		guideId: "londres",
		slug: "londres",
		name: "Londres",
		widePromo: true,
		ogImage: "/og-londres.png",
		country: "Reino Unido",
		chip: "Reino Unido · Ciudad",
		days: 4,
		h1: "Guía de Londres: itinerario de 4 días",
		lead: "Westminster, Notting Hill, Camden y muchos más. Una guía de 4 días para no perderte en Londres.",
		seoTitle: "Guía de Londres 4 días",
		seoDescription:
			"Guía de Londres 4 días: Westminster, Notting Hill, Camden, Tube, Oyster, aeropuertos y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Londres es cara y enorme. Aquí los días van por zonas para no gastar el Oyster en vano.",
		ctaTitle: "Guarda tu guía de Londres",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["4 días", "Westminster", "Notting Hill", "Camden"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "ETA o visado",
				text: "Con pasaporte español necesitas ETA (se pide online). Si tu pasaporte es de otro país, revisa si necesitas ETA o visado.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de lugares de Londres se visitan sin reserva, pero conviene reservar con antelación atracciones como Sky Garden, Warner Bros. Studio Tour The Making of Harry Potter y algunos miradores o experiencias con horario asignado.",
			},
			{
				icon: "tip",
				title: "Propina e impuestos",
				text: "En Londres, dejar propina no es obligatorio. Muchos restaurantes añaden automáticamente un service charge, normalmente del 12,5 %, y si ya está incluido no hace falta dejar más.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Las zonas más recomendables son Westminster, si quieres estar cerca de muchos de los principales monumentos, Covent Garden y Soho, si buscas ambiente, restaurantes y una ubicación muy céntrica, South Bank, si prefieres estar junto al Támesis y bien comunicado, y Kensington, si buscas una zona más tranquila.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo G",
				text: "Si vienes de Europa, necesitarás adaptador. El enchufe británico es de tipo G.",
			},
			{
				icon: "card",
				title: "Contactless u Oyster",
				text: "El metro y los autobuses son la forma más práctica de moverse por Londres. Puedes pagar directamente con tarjeta contactless o móvil o usar una Oyster card. Para la mayoría de visitantes, contactless suele ser la opción más cómoda.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la ciudad",
		neighborhoods: [
			{
				name: "Westminster",
				text: "El corazón histórico y político de Londres con Big Ben, Westminster Abbey, el Parlamento británico y Buckingham Palace muy cerca.",
			},
			{
				name: "South Bank",
				text: "Un paseo junto al Támesis con el London Eye, vistas del skyline, Tate Modern y mucho ambiente junto al río.",
			},
			{
				name: "Tower y London Bridge",
				text: "Tower of London, Tower Bridge y Borough Market. Una zona muy completa para combinar historia, vistas y comida.",
			},
			{
				name: "Covent Garden, Soho y West End",
				text: "Una de las zonas más animadas del centro con teatros, restaurantes, tiendas y mucho ambiente a cualquier hora.",
			},
			{
				name: "Notting Hill y Kensington",
				text: "Calles bonitas, Portobello Road, Hyde Park y algunos de los museos más importantes de Londres.",
			},
			{
				name: "Camden",
				text: "Una zona diferente al centro, conocida por su mercado, el canal y un ambiente más alternativo.",
			},
			{
				name: "The City y Shoreditch",
				text: "El Londres financiero y moderno se mezcla aquí con una zona más creativa, llena de mercados, arte urbano, bares y restaurantes.",
			},
			{
				name: "Greenwich",
				text: "Una zona más tranquila junto al Támesis con el Royal Observatory, el parque y el famoso meridiano.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "Contactless u Oyster",
					text: "Paga metro, autobuses y otros transportes con tarjeta contactless o móvil. También puedes usar una Oyster. El sistema aplica límites diarios y semanales según las zonas recorridas.",
				},
				{
					icon: "transit",
					title: "Tube y Overground",
					text: "Comprueba siempre la línea, la dirección y el destino antes de subir. Algunas estaciones son grandes y tienen varias salidas.",
				},
				{
					icon: "direction",
					title: "Zonas 1 a 6",
					text: "La mayoría de lugares turísticos están en las zonas 1 y 2. Cuantas más zonas atravieses, más puede costar el trayecto.",
				},
				{
					icon: "airport",
					title: "Desde el aeropuerto",
					text: "Desde Heathrow, Elizabeth Line o Piccadilly Line. También puedes usar Heathrow Express, que llega rápido a Paddington pero suele ser más caro. Desde Gatwick, Thameslink o Gatwick Express. Desde Stansted, Stansted Express.",
				},
			],
		},
		itineraryTitle: "Itinerario de 4 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Londres histórico y ribera del Támesis",
			},
			{
				day: 2,
				title: "Westminster y el corazón de Londres",
			},
			{
				day: 3,
				title: "Notting Hill, Hyde Park y Knightsbridge",
			},
			{
				day: 4,
				title: "Camden, Oxford St y zona de compras",
			},
		],
		hub: [
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/londres",
				icon: "preview",
			},
			{
				title: "Organiza tu ruta",
				text: "Crea tu recorrido por Londres y elige los lugares que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Londres con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Cuatro días por zonas, para no cruzar Londres tres veces.",
			},
			{
				icon: "museum",
				title: "Museos e iconos",
				text: "Westminster, Tower Bridge y una selección de museos sin empacho.",
			},
			{
				icon: "transit",
				title: "Mapas y Tube",
				text: "Oyster, contactless y cómo llegar desde Heathrow o Gatwick.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "nightlife",
				title: "Barrios con alma",
				text: "Notting Hill, Camden y el after que sí merece.",
			},
			{
				icon: "store",
				title: "Mercados y compras",
				text: "Camden, Oxford Street y las paradas que compensan.",
			},
		],
		related: ["edimburgo", "paris", "belgica"],
	},
	paris: {
		guideId: "paris",
		slug: "paris",
		name: "París",
		widePromo: true,
		ogImage: "/og-paris.png",
		country: "Francia",
		chip: "Francia · Ciudad",
		days: 4,
		h1: "Guía de París: itinerario de 4 días",
		lead: "Torre Eiffel, Louvre, Montmartre y muchos más. Una guía de 4 días para no perderte en París.",
		seoTitle: "Guía de París 4 días",
		seoDescription:
			"Guía de París 4 días: Île de la Cité, Louvre, Montmartre, Torre Eiffel, metro y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"París se disfruta a pie si no intentas Louvre, Versailles y Montmartre el mismo día.",
		ctaTitle: "Guarda tu guía de París",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["4 días", "Louvre", "Montmartre", "Torre Eiffel"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "Documento y Schengen",
				text: "Con DNI o pasaporte español no necesitas visado. Si tu documento es de otro país, revisa si necesitas visado Schengen.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de lugares de París se pueden visitar sin reserva, pero conviene comprar con antelación las entradas para la Torre Eiffel, el Museo del Louvre, la Sainte-Chapelle y, si quieres subir, el Arco del Triunfo. También merece la pena reservar antes si quieres visitar Versalles en una fecha concreta.",
			},
			{
				icon: "tip",
				title: "Propina e impuestos",
				text: "En Francia el servicio suele estar incluido en la cuenta. No es obligatorio dejar propina. Los precios mostrados ya incluyen los impuestos.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Las zonas más recomendables son Le Marais, si quieres ambiente, calles con encanto y una ubicación céntrica, Saint-Germain-des-Prés, si buscas una zona agradable para pasear, Opéra y alrededores, si priorizas buenas conexiones y una ubicación práctica, y Montmartre, si prefieres un ambiente más bohemio y no te importa estar algo más alejado del centro.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo E",
				text: "Si vienes de España, el enchufe es compatible. Si vienes de Reino Unido o Estados Unidos, necesitarás adaptador.",
			},
			{
				icon: "card",
				title: "Navigo o ticket",
				text: "El metro y el RER son la forma más práctica de moverse por París. Puedes cargar los billetes en una Navigo Easy o directamente en el móvil. El billete Metro-Train-RER sirve para metro, tren y RER en toda Île-de-France, excepto para los aeropuertos, que requieren un billete específico.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la ciudad",
		neighborhoods: [
			{
				name: "Île de la Cité y Barrio Latino",
				text: "El corazón histórico de París con Notre-Dame, Sainte-Chapelle, librerías, cafés y algunas de las calles con más ambiente de la ciudad.",
			},
			{
				name: "Louvre y Palais Royal",
				text: "Una de las zonas más monumentales de la ciudad con el Louvre, las Tullerías, Palais Royal y paseos junto al Sena.",
			},
			{
				name: "Le Marais",
				text: "Uno de los barrios más agradables para pasear con plazas, tiendas, cafés y mucho ambiente durante todo el día.",
			},
			{
				name: "Montmartre",
				text: "La zona más bohemia de París con Sacré-Cœur, Place du Tertre, calles con encanto y algunas de las mejores vistas de la ciudad.",
			},
			{
				name: "Torre Eiffel y Champ de Mars",
				text: "Una de las zonas más icónicas de París con la Torre Eiffel, el Champ de Mars y buenos paseos junto al Sena.",
			},
			{
				name: "Saint-Germain-des-Prés",
				text: "Cafés históricos, librerías, calles elegantes y uno de los ambientes más clásicos de la ciudad.",
			},
			{
				name: "Champs-Élysées y Arco de Triunfo",
				text: "La gran avenida de París con tiendas, edificios monumentales y el Arco de Triunfo como protagonista.",
			},
			{
				name: "Opéra y Grands Boulevards",
				text: "Una zona muy céntrica con la Ópera Garnier, grandes almacenes, tiendas y buenas conexiones de transporte.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "Navigo Easy o móvil",
					text: "Puedes pagar metro, RER, trenes y autobuses con Navigo Easy o directamente desde el móvil. Para los aeropuertos se aplican billetes específicos.",
				},
				{
					icon: "transit",
					title: "Metro y RER",
					text: "Comprueba siempre el número o la letra de la línea, la dirección y el destino antes de subir. Los cambios entre líneas están bien señalizados dentro de las estaciones.",
				},
				{
					icon: "direction",
					title: "Orilla derecha e izquierda",
					text: "El Sena divide París entre la Rive Droite y la Rive Gauche. Agrupar las visitas por zonas te ayudará a ahorrar tiempo y desplazamientos.",
				},
				{
					icon: "airport",
					title: "Desde CDG u Orly",
					text: "Desde Charles de Gaulle, el RER B conecta directamente con el centro. Desde Orly, la línea 14 del metro es una de las opciones más cómodas y directas para llegar a París.",
				},
			],
		},
		itineraryTitle: "Itinerario de 4 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Île de la Cité + Barrio Latino + Luxemburgo",
			},
			{
				day: 2,
				title: "Louvre + centro elegante de París",
			},
			{
				day: 3,
				title: "Montmartre + Le Marais",
			},
			{
				day: 4,
				title: "Torre Eiffel + Sena + Orsay",
			},
		],
		hub: [
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/paris",
				icon: "preview",
			},
			{
				title: "Organiza tu ruta",
				text: "Crea tu recorrido por París y elige los lugares que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de París con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Cuatro días por orillas y barrios, no por checklist.",
			},
			{
				icon: "museum",
				title: "Museos con criterio",
				text: "Louvre, Orsay y una dosis realista de colas y reservas.",
			},
			{
				icon: "transit",
				title: "Mapas y transporte",
				text: "Navigo, metro y cómo llegar desde CDG u Orly.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "nightlife",
				title: "Barrios para perderse",
				text: "Le Marais, Montmartre y el ritmo de cada orilla.",
			},
			{
				icon: "food",
				title: "Comer más que croissant",
				text: "Bistrós, mercados y zonas donde no pagas solo la terraza.",
			},
		],
		related: ["londres", "belgica", "nueva-york"],
	},
	seul: {
		guideId: "seul",
		slug: "seul",
		name: "Seúl",
		widePromo: true,
		ogImage: "/og-seul.png",
		country: "Corea del Sur",
		chip: "Corea del Sur · Ciudad",
		days: 5,
		h1: "Guía de Seúl: itinerario de 5 días",
		lead: "Gyeongbokgung, Myeongdong, Gangnam y muchos más. Una guía de 5 días para no perderte en Seúl.",
		seoTitle: "Guía de Seúl 5 días",
		seoDescription:
			"Guía de Seúl 5 días: Gyeongbokgung, Myeongdong, Gangnam, Hongdae, T-Money, metro y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Seúl mezcla palacios y neón. El plan ya está hecho por zonas para que no gastes el día en el metro.",
		ctaTitle: "Guarda tu guía de Seúl",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["5 días", "Gyeongbokgung", "Myeongdong", "Gangnam"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "K-ETA o visado",
				text: "Con pasaporte español puedes entrar en Corea del Sur sin visado hasta 90 días. Actualmente no necesitas K-ETA, aunque esta exención es temporal, así que conviene comprobar los requisitos antes de viajar. Sí debes completar la e-Arrival Card antes de llegar. Si tienes otra nacionalidad, revisa los requisitos específicos.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de lugares de Seúl se visitan sin reserva. Conviene reservar con antelación el Jardín Secreto de Changdeokgung y algunas experiencias o visitas con plazas limitadas. Para Lotte World, comprar la entrada online puede ahorrarte tiempo, pero no suele ser imprescindible reservar con mucha antelación.",
			},
			{
				icon: "tip",
				title: "Dinero y propinas",
				text: "En Corea no se deja propina. La tarjeta está muy extendida, pero conviene llevar algo de efectivo, especialmente para recargar una T-money, ya que algunas máquinas todavía solo aceptan efectivo.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Las zonas más recomendables son Myeongdong, si quieres una ubicación céntrica y práctica para una primera visita, Hongdae, si buscas ambiente joven, restaurantes y vida nocturna, Insadong/Jongno, si prefieres estar cerca de palacios, templos y zonas tradicionales, y Gangnam, si te interesa el Seúl más moderno, aunque queda más alejado de muchas visitas turísticas.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo C/F",
				text: "Si vienes de España, el enchufe es compatible. El voltaje es 220 V.",
			},
			{
				icon: "card",
				title: "T-Money",
				text: "El metro y los autobuses son la forma más práctica de moverse por Seúl. Con una T-Money puedes pagar metro, autobuses y también en algunos comercios.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la ciudad",
		neighborhoods: [
			{
				name: "Gyeongbokgung y Bukchon",
				text: "La zona más tradicional de Seúl con el palacio Gyeongbokgung, las casas hanok de Bukchon y calles históricas muy agradables para pasear.",
			},
			{
				name: "Insadong e Ikseon-dong",
				text: "Dos zonas con mucho encanto, llenas de casas tradicionales, tiendas, cafés y restaurantes en pleno centro histórico.",
			},
			{
				name: "Myeongdong y Namsan",
				text: "Una de las zonas más animadas del centro con tiendas, street food y acceso a la N Seoul Tower.",
			},
			{
				name: "Dongdaemun y DDP",
				text: "Una zona moderna y comercial conocida por el Dongdaemun Design Plaza, centros comerciales y ambiente hasta tarde.",
			},
			{
				name: "Gangnam y COEX",
				text: "El Seúl más moderno al sur del río Han con grandes avenidas, centros comerciales, COEX y mucho ambiente urbano.",
			},
			{
				name: "Hongdae",
				text: "Uno de los barrios más jóvenes de Seúl con tiendas, cafés, música, restaurantes y vida nocturna.",
			},
			{
				name: "Seongsu",
				text: "Una antigua zona industrial transformada en uno de los barrios más de moda con cafés, tiendas de diseño y pop-ups.",
			},
			{
				name: "Itaewon",
				text: "Una zona con restaurantes, bares y ambiente nocturno.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "T-Money",
					text: "Úsala para pagar metro, autobuses y algunos comercios. Para la mayoría de viajeros, la tarjeta física sigue siendo la opción más sencilla.",
				},
				{
					icon: "transit",
					title: "Metro",
					text: "Comprueba siempre el número de la línea, la dirección y el destino antes de subir. Las estaciones y los avisos suelen estar también en inglés.",
				},
				{
					icon: "direction",
					title: "Norte y sur del río Han",
					text: "Los palacios, Myeongdong y gran parte del centro histórico están al norte del río. Gangnam, COEX y Apgujeong quedan al sur.",
				},
				{
					icon: "airport",
					title: "Desde Incheon o Gimpo",
					text: "Desde Incheon, el AREX conecta directamente con Seoul Station. Desde Gimpo, el metro permite llegar fácilmente a distintas zonas de la ciudad.",
				},
			],
		},
		itineraryTitle: "Itinerario de 5 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Gwanghwamun, Gyeongbokgung y Bukchon",
			},
			{
				day: 2,
				title: "Cheonggyecheon, Myeongdong y Namsan",
			},
			{
				day: 3,
				title: "Changdeokgung, Ikseon-dong y DDP",
			},
			{
				day: 4,
				title: "Seongsu, COEX, Gangnam y Apgujeong",
			},
			{
				day: 5,
				title: "Deoksugung, City Hall y Hongdae",
			},
		],
		hub: [
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/seul",
				icon: "preview",
			},
			{
				title: "Organiza tu ruta",
				text: "Crea tu recorrido por Seúl y elige los lugares que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Seúl con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Cinco días por zonas, para no cruzar Seúl tres veces.",
			},
			{
				icon: "temple",
				title: "Palacios y hanok",
				text: "Gyeongbokgung, Bukchon y el contraste con el skyline.",
			},
			{
				icon: "transit",
				title: "Mapas y transporte",
				text: "T-Money, metro y cómo llegar desde Incheon.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "nightlife",
				title: "Barrios con vida",
				text: "Hongdae, Myeongdong y Gangnam: compras, música y luces.",
			},
			{
				icon: "store",
				title: "Compras y cafés",
				text: "K-beauty, Seongsu y las tiendas que sí merecen una parada.",
			},
		],
		related: ["tokio", "osaka", "bangkok"],
	},
	bangkok: {
		guideId: "bangkok",
		slug: "bangkok",
		name: "Bangkok",
		widePromo: true,
		ogImage: "/og-bangkok.png",
		country: "Tailandia",
		chip: "Tailandia · Ciudad",
		days: 4,
		h1: "Guía de Bangkok: itinerario de 4 días",
		lead: "Wat Arun, el Gran Palacio, Chinatown y muchos más. Una guía de 4 días para no perderte en Bangkok.",
		seoTitle: "Guía de Bangkok 4 días",
		seoDescription:
			"Guía de Bangkok 4 días: Gran Palacio, Wat Pho, Wat Arun, Chinatown, Chatuchak, BTS, MRT y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Bangkok se entiende por orillas y barrios. El plan ya está hecho para que no gastes la tarde en el tráfico.",
		ctaTitle: "Guarda tu guía de Bangkok",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["4 días", "Wat Arun", "Gran Palacio", "Chinatown"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "Visado y TDAC",
				text: "Con pasaporte español puedes entrar en Tailandia sin visado hasta 30 días. Sí debes completar la TDAC (tarjeta digital de llegada) en las 72 horas anteriores a llegar. El pasaporte tiene que tener al menos 6 meses de validez. Si tienes otra nacionalidad, revisa los requisitos específicos.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de lugares de Bangkok se visitan sin reserva. El Gran Palacio, Wat Pho y Wat Arun se compran en taquilla. Conviene reservar con antelación tours a mercados flotantes y algunos rooftops o experiencias con plazas limitadas.",
			},
			{
				icon: "tip",
				title: "Dinero y propinas",
				text: "La propina no es obligatoria, aunque en restaurantes se agradece dejar un poco. La tarjeta funciona en centros comerciales y hoteles, pero en mercados y street food hace falta efectivo.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Para una primera visita, Siam es muy práctica por su ubicación céntrica y el BTS. Sukhumvit tiene muchísima oferta de hoteles, restaurantes y ocio. Silom y Sathorn son buenas opciones si buscas una zona moderna, bien comunicada y con rooftops. Riverside es ideal si prefieres alojarte junto al Chao Phraya y cerca de varios templos. Khao San tiene más ambiente mochilero y suele ser menos cómoda para moverse por la ciudad.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo A, B y C",
				text: "Si vienes de España, el enchufe europeo de tipo C suele ser compatible, aunque no siempre. Conviene llevar un adaptador universal por si acaso. El voltaje en Tailandia es de 220 V.",
			},
			{
				icon: "card",
				title: "Rabbit y BTS",
				text: "El BTS y el MRT son dos de las formas más prácticas de moverse por Bangkok y evitar el tráfico. La Rabbit Card sirve para pagar el BTS, mientras que el MRT utiliza su propio sistema de pago. Grab es una buena alternativa cuando no tienes ninguna estación cerca.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la ciudad",
		neighborhoods: [
			{
				name: "Old Town y Gran Palacio",
				text: "El corazón histórico de Bangkok con el Gran Palacio, Wat Pho y algunos de los templos más importantes de la ciudad.",
			},
			{
				name: "Thonburi y Wat Arun",
				text: "La orilla oeste del Chao Phraya con Wat Arun, canales tradicionales y un ambiente más tranquilo que en el centro.",
			},
			{
				name: "Khao San y Wat Saket",
				text: "Una zona animada y popular entre viajeros con Khao San Road, Wat Saket y el Golden Mount muy cerca.",
			},
			{
				name: "Chinatown (Yaowarat)",
				text: "Una de las mejores zonas para comer street food y pasear por la noche entre neones, mercados y calles llenas de ambiente.",
			},
			{
				name: "Siam",
				text: "El gran centro comercial de Bangkok con enormes centros comerciales, buenas conexiones en BTS y lugares como Jim Thompson House.",
			},
			{
				name: "Silom y Lumphini",
				text: "Una zona moderna y bien comunicada con rooftops, restaurantes y el parque Lumphini como gran espacio verde del centro.",
			},
			{
				name: "Sukhumvit",
				text: "Una de las zonas más prácticas para alojarse con hoteles, restaurantes, centros comerciales y mucha vida nocturna.",
			},
			{
				name: "Chatuchak",
				text: "Conocida por su enorme mercado de fin de semana, uno de los más famosos de Bangkok, con miles de puestos de todo tipo.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "Rabbit",
					text: "Úsala para pagar el BTS. Para la mayoría de viajeros, la tarjeta física es la opción más sencilla.",
				},
				{
					icon: "transit",
					title: "BTS y MRT",
					text: "El BTS es el metro elevado y el MRT el subterráneo. Son redes distintas. Comprueba siempre la línea, la dirección y el destino antes de subir.",
				},
				{
					icon: "direction",
					title: "Río Chao Phraya",
					text: "Los barcos del Chao Phraya Express conectan el Gran Palacio, Wat Arun y otras zonas junto al río. Evitan el tráfico y tienen buenas vistas.",
				},
				{
					icon: "airport",
					title: "Desde Suvarnabhumi o Don Mueang",
					text: "Desde Suvarnabhumi, el Airport Rail Link llega a Phaya Thai, donde enlazas con el BTS. Desde Don Mueang, el bus o Grab conectan con el BTS y el MRT. El tráfico puede alargar mucho el taxi.",
				},
			],
		},
		itineraryTitle: "Itinerario de 4 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Templos imprescindibles",
			},
			{
				day: 2,
				title: "Bangkok tradicional",
			},
			{
				day: 3,
				title: "Siam y Chinatown",
			},
			{
				day: 4,
				title: "Mercados",
			},
			{
				day: 5,
				title: "Extra: Ayutthaya",
			},
		],
		hub: [
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/bangkok",
				icon: "preview",
			},
			{
				title: "Organiza tu ruta",
				text: "Crea tu recorrido por Bangkok y elige los lugares que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Bangkok con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Cuatro días por orillas y barrios, con el río y el BTS de referencia.",
			},
			{
				icon: "temple",
				title: "Templos del río",
				text: "Gran Palacio, Wat Pho y Wat Arun, en el orden que marca el río.",
			},
			{
				icon: "transit",
				title: "Mapas y transporte",
				text: "Rabbit, BTS, MRT y cómo llegar desde Suvarnabhumi o Don Mueang.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "food",
				title: "Street food y mercados",
				text: "Chinatown, Chatuchak y los puestos que sí merecen una parada.",
			},
			{
				icon: "store",
				title: "Siam y compras",
				text: "Centros comerciales, Jim Thompson y el contraste con los mercados.",
			},
		],
		related: ["kuala-lumpur", "bali", "seul"],
	},
	"kuala-lumpur": {
		guideId: "kualaLumpur",
		slug: "kuala-lumpur",
		name: "Kuala Lumpur",
		widePromo: true,
		ogImage: "/og-kuala-lumpur.png",
		country: "Malasia",
		chip: "Malasia · Ciudad",
		days: 3,
		h1: "Guía de Kuala Lumpur: itinerario de 3 días",
		lead: "Torres Petronas, Batu Caves, Chinatown y muchos más. Una guía de 3 días para no perderte en Kuala Lumpur.",
		seoTitle: "Guía de Kuala Lumpur 3 días",
		seoDescription:
			"Guía de Kuala Lumpur 3 días: Torres Petronas, Bukit Bintang, Chinatown, Batu Caves, Touch n Go, KLIA y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Kuala Lumpur se entiende por barrios y un par de salidas. El plan ya está hecho para que no gastes la mañana en un centro comercial.",
		ctaTitle: "Guarda tu guía de Kuala Lumpur",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["3 días", "Petronas", "Batu Caves", "Chinatown"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "Visado y MDAC",
				text: "Con pasaporte español puedes entrar en Malasia sin visado hasta 90 días. Sí debes completar la MDAC (Malaysia Digital Arrival Card) en los 3 días anteriores a llegar. El pasaporte tiene que tener al menos 6 meses de validez. Si tienes otra nacionalidad, revisa los requisitos específicos.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de lugares de Kuala Lumpur se visitan sin reserva. Conviene reservar con antelación las Torres Petronas, porque las entradas del mirador se agotan. Batu Caves y la mayoría de templos no necesitan reserva.",
			},
			{
				icon: "tip",
				title: "Dinero y propinas",
				text: "La propina no es obligatoria, aunque en algunos restaurantes el servicio ya viene incluido. La tarjeta está muy extendida en centros comerciales y hoteles, pero conviene llevar efectivo para puestos de comida, mercados y pequeños comercios.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Para una primera visita, KLCC es muy práctica: céntrica, moderna y con muchos hoteles y apartamentos con piscina y vistas a las Torres Petronas. Bukit Bintang funciona si buscas ambiente, restaurantes y compras. Chinatown es más económica y tiene más carácter local.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo G",
				text: "Si vienes de España, necesitarás adaptador. El enchufe es de tipo G, el mismo que en Reino Unido. El voltaje es 240 V.",
			},
			{
				icon: "card",
				title: "Touch 'n Go",
				text: "El MRT, el LRT y el monorraíl son la forma más práctica de moverse por Kuala Lumpur. Con una Touch 'n Go pagas transporte y también en muchos comercios. Grab es útil cuando no hay estación cerca.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la ciudad",
		neighborhoods: [
			{
				name: "KLCC",
				text: "La zona más moderna e icónica de Kuala Lumpur con las Torres Petronas, KLCC Park y algunos de los centros comerciales más conocidos de la ciudad.",
			},
			{
				name: "Bukit Bintang",
				text: "Una de las zonas más animadas, ideal para compras, restaurantes y salir por la noche. Jalan Alor queda muy cerca.",
			},
			{
				name: "Merdeka Square y centro histórico",
				text: "El corazón histórico de Kuala Lumpur con edificios coloniales, la Mezquita Jamek y el River of Life.",
			},
			{
				name: "Chinatown",
				text: "Una zona muy animada alrededor de Petaling Street con mercados, templos, comida y mucho ambiente.",
			},
			{
				name: "Brickfields / Little India",
				text: "El barrio indio de Kuala Lumpur con templos, restaurantes y tiendas tradicionales muy cerca de KL Sentral.",
			},
			{
				name: "Perdana Botanical Gardens y Mezquita Nacional",
				text: "Una zona más verde y tranquila con los Perdana Botanical Gardens, la Mezquita Nacional y varios museos y edificios importantes alrededor.",
			},
			{
				name: "Bukit Nanas y KL Tower",
				text: "Una zona verde en pleno centro donde se encuentra la KL Tower y uno de los miradores más conocidos de la ciudad.",
			},
			{
				name: "Batu Caves",
				text: "Una de las visitas más conocidas a las afueras de Kuala Lumpur, famosa por su enorme estatua de Murugan y las escaleras de colores.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "Touch 'n Go",
					text: "Úsala para pagar MRT, LRT, monorraíl, buses y algunos comercios. Para la mayoría de viajeros, la tarjeta física es la opción más sencilla.",
				},
				{
					icon: "transit",
					title: "MRT, LRT y monorraíl",
					text: "Son redes distintas, pero se pagan con la misma tarjeta. Comprueba siempre la línea, la dirección y el destino antes de subir.",
				},
				{
					icon: "direction",
					title: "KL Sentral",
					text: "Es el hub principal de la ciudad. Desde aquí conectas con casi todas las líneas y con el tren del aeropuerto.",
				},
				{
					icon: "airport",
					title: "Desde KLIA o KLIA2",
					text: "El KLIA Ekspres llega directo a KL Sentral en unos 28 minutos. También hay bus y Grab. KLIA2 es la terminal de low cost y también tiene conexión con el Ekspres.",
				},
			],
		},
		itineraryTitle: "Itinerario de 3 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Torres Petronas y Bukit Bintang",
			},
			{
				day: 2,
				title: "Merdeka Square y barrios de KL",
			},
			{
				day: 3,
				title: "Batu Caves",
			},
			{
				day: 4,
				title: "Excursiones",
			},
		],
		hub: [
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/kualaLumpur",
				icon: "preview",
			},
			{
				title: "Organiza tu ruta",
				text: "Crea tu recorrido por Kuala Lumpur y elige los lugares que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Kuala Lumpur con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Tres días por KLCC, barrios históricos y Batu Caves.",
			},
			{
				icon: "skyline",
				title: "Torres y miradores",
				text: "Petronas, KL Tower y el skyline desde KLCC.",
			},
			{
				icon: "transit",
				title: "Mapas y transporte",
				text: "Touch 'n Go, MRT y cómo llegar desde KLIA o KLIA2.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "temple",
				title: "Templos y cuevas",
				text: "Batu Caves, Thean Hou y el contraste con las mezquitas.",
			},
			{
				icon: "food",
				title: "Hawker y street food",
				text: "Jalan Alor, Chinatown y Little India.",
			},
		],
		related: ["bangkok", "bali", "pekin"],
	},
	belgica: {
		guideId: "belgica",
		slug: "belgica",
		name: "Bélgica",
		widePromo: true,
		ogImage: "/og-belgica.png",
		country: "Bélgica",
		chip: "Europa · País",
		days: 5,
		h1: "Guía de Bélgica: itinerario de 5 días",
		lead: "Bruselas, Amberes, Gante y Brujas. Una guía de 5 días para no perderte en Bélgica.",
		seoTitle: "Guía de Bélgica 5 días",
		seoDescription:
			"Guía de Bélgica 5 días: Bruselas, Amberes, Gante, Brujas, tren SNCB, Zaventem, Charleroi y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Bélgica se entiende por ciudades cortas en tren. El plan ya está hecho para no intentar tres el mismo día.",
		ctaTitle: "Guarda tu guía de Bélgica",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["5 días", "Bruselas", "Brujas", "Gante"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "Documento y Schengen",
				text: "Con DNI o pasaporte español no necesitas visado. Si tu documento es de otro país, revisa si necesitas visado Schengen.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de lugares de Bélgica se visitan sin reserva. Para el Atomium, comprar la entrada online puede ahorrarte tiempo, sobre todo en temporada alta. En Brujas, los paseos en barco por los canales suelen comprarse al momento, aunque en los meses más concurridos puede haber bastante cola.",
			},
			{
				icon: "tip",
				title: "Dinero y propinas",
				text: "En Bélgica el servicio suele estar incluido. No es obligatorio dejar propina. Las tarjetas se aceptan en casi todo el país.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Para moverte en tren, Bruselas es la base más práctica, ya que desde Bruxelles-Central o Bruxelles-Midi puedes llegar fácilmente a Amberes, Gante y Brujas. Si quieres disfrutar Brujas con más calma y verla cuando hay menos visitantes, merece la pena pasar al menos una noche allí.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo E/F",
				text: "Si vienes de España, el enchufe es compatible. El voltaje es 230 V.",
			},
			{
				icon: "card",
				title: "Tren SNCB",
				text: "El tren es la forma más práctica de moverse entre ciudades. Bruselas-Gante son unos 30 minutos, Bruselas-Amberes unos 40 y Bruselas-Brujas alrededor de una hora.",
			},
		],
		neighborhoodsTitle: "Ciudades de Bélgica",
		neighborhoods: [
			{
				name: "Bruselas",
				text: "La capital y una de las mejores bases para moverte en tren por el país, con la Grand Place, el Atomium y barrios muy diferentes entre sí.",
			},
			{
				name: "Brujas",
				text: "Canales, casas medievales y un centro histórico muy bien conservado. Una de las ciudades más visitadas de Bélgica.",
			},
			{
				name: "Gante",
				text: "Una ciudad con mucho ambiente, canales, edificios históricos y uno de los castillos más conocidos del país.",
			},
			{
				name: "Amberes",
				text: "Una ciudad más grande y urbana, conocida por la moda, los museos, la arquitectura y su impresionante estación central.",
			},
			{
				name: "Lovaina",
				text: "Una ciudad universitaria muy animada con un centro histórico compacto y fácil de visitar.",
			},
			{
				name: "Malinas",
				text: "Más tranquila y menos turística con un centro histórico agradable y buenas conexiones entre Bruselas y Amberes.",
			},
			{
				name: "Dinant",
				text: "Una pequeña ciudad a orillas del Mosa, conocida por su ciudadela, la colegiata y las casas junto al río. Es una buena excursión si buscas un paisaje diferente al de Bruselas, Brujas o Gante.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "Tren SNCB",
					text: "Es la forma más cómoda de moverse entre ciudades. Compra el billete antes de subir, desde la web, la app, las máquinas o la taquilla. Desde julio de 2026 ya no se venden billetes a bordo.",
				},
				{
					icon: "transit",
					title: "Billetes y descuentos",
					text: "La SNCB ofrece tarifas reducidas en fines de semana, además de precios especiales según la edad. Si tienes menos de 26 años, revisa las tarifas Youth antes de comprar.",
				},
				{
					icon: "direction",
					title: "Tiempos entre ciudades",
					text: "Desde Bruselas, Gante está a unos 30 minutos, Amberes a unos 40 y Brujas alrededor de una hora. Es fácil hacer excursiones de un día en tren.",
				},
				{
					icon: "airport",
					title: "Desde Zaventem o Charleroi",
					text: "Desde Brussels Airport-Zaventem, el tren llega a Bruxelles-Central en unos 18 minutos. Desde Charleroi, el bus Flibco conecta directamente con Bruxelles-Midi en unos 55–60 minutos.",
				},
			],
		},
		itineraryTitle: "Itinerario de 5 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Bruselas",
			},
			{
				day: 2,
				title: "Amberes",
			},
			{
				day: 3,
				title: "Gante",
			},
			{
				day: 4,
				title: "Brujas",
			},
			{
				day: 5,
				title: "Bruselas",
			},
		],
		hub: [
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/belgica",
				icon: "preview",
			},
			{
				title: "Organiza tu ruta",
				text: "Crea tu recorrido por Bélgica y elige los lugares que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Bélgica con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Cinco días: Bruselas, Amberes, Gante, Brujas y vuelta.",
			},
			{
				icon: "museum",
				title: "Bruselas",
				text: "Grand Place, Manneken Pis, Galerías y Atomium.",
			},
			{
				icon: "transit",
				title: "Mapas y transporte",
				text: "SNCB, tiempos reales y cómo llegar desde Zaventem o Charleroi.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "temple",
				title: "Gante y Brujas",
				text: "Canales, plazas y centros que se recorren a pie.",
			},
			{
				icon: "food",
				title: "Chocolate y cerveza",
				text: "Chocolaterías, cervezas trapenses y gofres.",
			},
		],
		related: ["paris", "londres", "seul"],
	},
	pekin: {
		guideId: "pekin",
		slug: "pekin",
		name: "Pekín",
		widePromo: true,
		ogImage: "/og-pekin.png",
		country: "China",
		chip: "China · Ciudad",
		days: 3,
		h1: "Guía de Pekín: itinerario de 3 días",
		lead: "Ciudad Prohibida, Palacio de Verano, Gran Muralla y muchos más. Una guía de 3 días para no perderte en Pekín.",
		seoTitle: "Guía de Pekín 3 días",
		seoDescription:
			"Guía de Pekín 3 días: Ciudad Prohibida, Tiananmén, Templo del Cielo, Palacio de Verano, Gran Muralla, metro y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Pekín se entiende por ejes: centro imperial, noroeste y Muralla. El plan ya está hecho por zonas.",
		ctaTitle: "Guarda tu guía de Pekín",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["3 días", "Ciudad Prohibida", "Gran Muralla", "Tiananmén"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "Visado",
				text: "Con pasaporte español puedes entrar en China sin visado hasta 30 días. Esta exención es temporal y está vigente hasta el 31 de diciembre de 2026, así que conviene comprobar los requisitos antes de viajar. Además, debes completar la Arrival Card con tus datos de entrada. Si tienes otra nacionalidad, revisa los requisitos específicos.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "Conviene reservar con antelación la Ciudad Prohibida, ya que las entradas son limitadas y pueden agotarse. Para visitar tramos populares de la Gran Muralla, como Mutianyu, también es recomendable comprar la entrada con antelación. El Palacio de Verano y el Templo del Cielo suelen ser más fáciles de visitar, aunque en temporada alta puede ser útil llevar la entrada comprada.",
			},
			{
				icon: "tip",
				title: "Dinero y pagos",
				text: "En China no se deja propina. Los pagos móviles con Alipay y WeChat Pay están muy extendidos. Conviene llevar también algo de efectivo y una tarjeta bancaria por si acaso, aunque en muchos comercios y transportes se paga principalmente con Alipay o WeChat Pay.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Lo más práctico es alojarse cerca de una estación de metro. Wangfujing es muy céntrica y está bien comunicada. Dongsi es más tranquila y sigue teniendo buen metro. Qianmen queda junto a Tiananmén y la Ciudad Prohibida. Gulou o Nanluoguxiang funcionan si prefieres hutongs y un ambiente más de barrio.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo A y C",
				text: "Si vienes de España, el enchufe europeo de tipo C suele ser compatible, aunque también encontrarás tomas de tipo A. Conviene llevar un adaptador universal por si acaso. El voltaje en China es de 220 V.",
			},
			{
				icon: "card",
				title: "Yikatong",
				text: "El metro es una de las formas más prácticas de moverse por Pekín. Con una Yikatong puedes pagar metro y autobuses. También puedes comprar billetes sueltos en las máquinas de las estaciones o usar opciones de pago móvil compatibles.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la ciudad",
		neighborhoods: [
			{
				name: "Tiananmén y Ciudad Prohibida",
				text: "El corazón histórico de Pekín con la Plaza de Tiananmén, la Ciudad Prohibida y el parque Jingshan justo al norte.",
			},
			{
				name: "Qianmen y Dashilar",
				text: "Una de las zonas más tradicionales del centro con calles peatonales, comercios históricos y mucho ambiente junto a Tiananmén.",
			},
			{
				name: "Wangfujing",
				text: "Una zona muy céntrica y comercial con tiendas, restaurantes y buenas conexiones de metro.",
			},
			{
				name: "Gulou y hutongs",
				text: "El Pekín más tradicional con callejuelas antiguas, la Torre del Tambor, la Torre de la Campana y Nanluoguxiang.",
			},
			{
				name: "Templo del Cielo",
				text: "Una gran zona monumental al sur del centro con el famoso templo rodeado por uno de los parques más importantes de la ciudad.",
			},
			{
				name: "Templo de los Lamas y Confucio",
				text: "Una zona de templos con el Lama Temple, el Templo de Confucio y calles tradicionales alrededor.",
			},
			{
				name: "Palacio de Verano",
				text: "El gran conjunto imperial al noroeste de Pekín con jardines, pabellones, el lago Kunming y el Corredor Largo.",
			},
			{
				name: "Sanlitun y CBD",
				text: "El Pekín más moderno con rascacielos, centros comerciales y restaurantes.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "Tarjeta contactless o móvil",
					text: "En el metro puedes pagar directamente con una tarjeta bancaria contactless o con el móvil. También puedes usar Yikatong o comprar billetes sueltos en las estaciones.",
				},
				{
					icon: "transit",
					title: "Metro",
					text: "Es la forma más práctica de moverse por Pekín. Comprueba siempre la línea, la dirección y el destino antes de subir.",
				},
				{
					icon: "taxi",
					title: "DiDi",
					text: "Muy útil para trayectos menos cómodos en metro o cuando llevas equipaje. Funciona de forma similar a Uber y puede usarse desde su app o mediante Alipay.",
				},
				{
					icon: "airport",
					title: "Desde PEK o Daxing",
					text: "Desde Capital (PEK), el Airport Express conecta con Dongzhimen y Sanyuanqiao. Desde Daxing (PKX), el Airport Express conecta con Caoqiao.",
				},
			],
		},
		itineraryTitle: "Itinerario de 3 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Ciudad Prohibida, Tiananmén y Templo del Cielo",
			},
			{
				day: 2,
				title: "Palacio de Verano y templos",
			},
			{
				day: 3,
				title: "Gran Muralla China",
			},
		],
		hub: [
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/pekin",
				icon: "preview",
			},
			{
				title: "Organiza tu ruta",
				text: "Crea tu recorrido por Pekín y elige los lugares que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Pekín con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Tres días: centro imperial, Palacio de Verano y Gran Muralla.",
			},
			{
				icon: "temple",
				title: "Iconos imperiales",
				text: "Ciudad Prohibida, Templo del Cielo y Palacio de Verano.",
			},
			{
				icon: "transit",
				title: "Mapas y transporte",
				text: "Yikatong, metro y cómo llegar desde PEK o Daxing.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "nightlife",
				title: "Hutongs y barrios",
				text: "Gulou, Qianmen y el Pekín que no es solo plaza.",
			},
			{
				icon: "food",
				title: "Comer en la capital",
				text: "Wangfujing, Snack Street y los hutongs para cenar.",
			},
		],
		related: ["seul", "tokio", "bangkok"],
	},
	bali: {
		guideId: "bali",
		slug: "bali",
		name: "Bali",
		widePromo: true,
		ogImage: "/og-bali.png",
		country: "Indonesia",
		chip: "Indonesia · Isla",
		days: 10,
		h1: "Guía de Bali: itinerario de 10 días",
		lead: "Ubud, Monte Batur, Nusa Penida, Uluwatu y muchos más. Una guía de 10 días para no perderte en Bali.",
		seoTitle: "Guía de Bali 10 días",
		seoDescription:
			"Guía de Bali 10 días: Ubud, Batur, este y norte, Nusa Penida, Canggu, Uluwatu, visado, aeropuerto y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Bali se entiende por zonas, no por un día de todo. El plan ya está hecho para no gastar el viaje en el tráfico.",
		ctaTitle: "Guarda tu guía de Bali",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: [
			"Itinerario por días",
			"Incluida en Premium o compra individual",
		],
		quickFacts: ["10 días", "Ubud", "Nusa Penida", "Uluwatu"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "Visado y Arrival Card",
				text: "Con pasaporte español necesitas visado para entrar en Indonesia. Puedes solicitar la e-VOA online o tramitar la Visa on Arrival al llegar. Cuesta 500.000 IDR, permite una estancia de 30 días y puede prorrogarse una vez por otros 30. El pasaporte debe tener al menos 6 meses de validez. Además, debes completar la All Indonesia Arrival Card antes de llegar y pagar la tasa turística de Bali de 150.000 IDR. Si tienes otra nacionalidad, revisa los requisitos específicos antes de viajar.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "La mayoría de lugares de Bali se visitan sin reserva. Lo que más conviene reservar con antelación son algunas experiencias, excursiones y beach clubs populares, especialmente en temporada alta.",
			},
			{
				icon: "tip",
				title: "Dinero y propinas",
				text: "La propina no es obligatoria, aunque se agradece en restaurantes y con conductores. Lleva efectivo en rupias: muchos sitios no aceptan tarjeta.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Para los primeros días, Ubud es la base más práctica para templos, arrozales y el interior. Para la segunda parte, Canggu funciona si buscas playa y ambiente, y Uluwatu si prefieres acantilados y playas del sur. Evita cambiar de zona todos los días: los trayectos se alargan mucho con el tráfico.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo C y F",
				text: "Si vienes de España, el enchufe es compatible. El voltaje es 230 V.",
			},
			{
				icon: "card",
				title: "Grab y Gojek",
				text: "Para trayectos cortos, Grab y Gojek son opciones muy prácticas. Para excursiones de día, suele ser cómodo contratar un conductor privado. Si conduces moto, asegúrate de llevar el permiso internacional correspondiente y de que tu seguro cubra este tipo de vehículo.",
			},
		],
		neighborhoodsTitle: "Cómo está organizada la isla",
		neighborhoods: [
			{
				name: "Ubud",
				text: "En el interior de Bali, es uno de los principales centros culturales de la isla, con templos, mercados, arrozales y mucho ambiente.",
			},
			{
				name: "Tegallalang y centro de Bali",
				text: "Una zona de arrozales y templos al norte de Ubud, con lugares como Tirta Empul y Gunung Kawi.",
			},
			{
				name: "Kintamani y Monte Batur",
				text: "Una zona volcánica con vistas al Monte Batur y al lago, muy conocida por las excursiones al amanecer.",
			},
			{
				name: "Norte de Bali",
				text: "Una zona más tranquila, con Lovina, excursiones para ver delfines, cascadas y paisajes menos urbanizados.",
			},
			{
				name: "Bedugul y Ulun Danu Beratan",
				text: "Una zona de montaña y lagos, donde se encuentra el famoso templo Ulun Danu Beratan.",
			},
			{
				name: "Este de Bali y Besakih",
				text: "Una zona más tradicional, con el Templo de Besakih, el Monte Agung, Tirta Gangga y otros templos y paisajes del este.",
			},
			{
				name: "Canggu y Seminyak",
				text: "Dos de las zonas más animadas de la costa con playas, restaurantes, cafés y beach clubs.",
			},
			{
				name: "Uluwatu y península de Bukit",
				text: "Acantilados, playas y el famoso templo de Uluwatu, especialmente bonito al atardecer.",
			},
			{
				name: "Nusa Dua",
				text: "Una zona tranquila del sur, conocida por sus resorts, playas cuidadas y ambiente relajado.",
			},
			{
				name: "Sanur",
				text: "Una zona tranquila junto al mar, con paseo marítimo y buenas conexiones para viajar a las islas cercanas.",
			},
			{
				name: "Nusa Penida",
				text: "Una isla cercana a Bali, famosa por sus acantilados, playas y miradores. Se puede visitar en excursión o pasando alguna noche.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "card",
					title: "Grab y Gojek",
					text: "Son las opciones más prácticas para trayectos cortos. En algunas zonas puede haber puntos de recogida concretos, así que a veces toca caminar un poco.",
				},
				{
					icon: "transit",
					title: "Moto",
					text: "Es una forma muy común de moverse por Bali, pero solo compensa si tienes experiencia. Necesitas carné internacional y conducir por la izquierda.",
				},
				{
					icon: "direction",
					title: "Conductor privado",
					text: "La opción más cómoda para excursiones de día y para recorrer varias paradas sin preocuparte por conducir.",
				},
				{
					icon: "airport",
					title: "Desde Ngurah Rai (DPS)",
					text: "El aeropuerto está al sur de la isla, cerca de Kuta y Jimbaran. Para llegar a otras zonas, lo más práctico es reservar transfer o usar taxi, Grab o Gojek. El tráfico puede alargar bastante los trayectos hacia Ubud, Canggu o Uluwatu.",
				},
			],
		},
		itineraryTitle: "Itinerario de 10 días de la guía",
		itineraryPreview: [
			{ day: 1, title: "Ubud" },
			{ day: 2, title: "Ubud y alrededores" },
			{ day: 3, title: "Monte Batur" },
			{ day: 4, title: "Este de Bali" },
			{ day: 5, title: "Norte de Bali + Tanah Lot" },
			{ day: 6, title: "Nusa Penida (Oeste)" },
			{ day: 7, title: "Nusa Penida (Este)" },
			{ day: 8, title: "Traslado + Uluwatu" },
			{ day: 9, title: "Uluwatu y playas del sur" },
			{ day: 10, title: "Relax y vuelta" },
		],
		hub: [
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/bali",
				icon: "preview",
			},
			{
				title: "Organiza tu ruta",
				text: "Crea tu recorrido por Bali y elige los lugares que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Bali con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Diez días por Ubud, Batur, Nusa Penida y el sur.",
			},
			{
				icon: "park",
				title: "Ubud y arrozales",
				text: "Templos, Tegalalang y el interior de la isla.",
			},
			{
				icon: "transit",
				title: "Mapas y transporte",
				text: "Grab, moto, driver y cómo llegar desde Ngurah Rai.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "Quita lo que no te va, mete tus reservas y deja la guía a tu medida.",
			},
			{
				icon: "beach",
				title: "Nusa Penida y el sur",
				text: "Acantilados, calas, Canggu y Uluwatu.",
			},
			{
				icon: "temple",
				title: "Templos",
				text: "Tirta Empul, Tanah Lot y Uluwatu.",
			},
		],
		related: ["bangkok", "kuala-lumpur", "seul"],
	},
	edimburgo: {
		guideId: "edimburgo",
		slug: "edimburgo",
		name: "Edimburgo",
		widePromo: true,
		ogImage: "/og-edimburgo.png",
		country: "Escocia",
		chip: "Escocia · Ciudad",
		days: 3,
		h1: "Guía de Edimburgo: itinerario de 3 días",
		lead: "Castillo, Royal Mile, Arthur’s Seat, Dean Village y, si tienes un día extra, alguna excursión desde Edimburgo. Una guía de 3 días para recorrer la ciudad a pie.",
		seoTitle: "Guía de Edimburgo 3 días",
		seoDescription:
			"Guía de Edimburgo 3 días: castillo, Royal Mile, Arthur’s Seat, Holyrood, Dean Village, ghost tour, Highlands, transporte y mapas. Preview gratis.",
		whyTitle: "Qué incluye esta guía",
		whyLead:
			"Edimburgo se recorre por capas: Old Town, volcán, New Town y un día fuera. El plan ya está partido para no subir Arthur’s Seat después del tour de fantasmas.",
		ctaTitle: "Guarda tu guía de Edimburgo",
		ctaLead:
			"Crea una cuenta para guardar esta guía, editarla y usar pasaporte, tarjeta viajera, rutas y álbum.",
		highlights: ["Itinerario por días", "Gratis con cuenta"],
		quickFacts: ["3 días", "Royal Mile", "Castillo Edimburgo", "Highlands"],
		cityFactsTitle: "Antes de aterrizar",
		cityFacts: [
			{
				icon: "visa",
				title: "ETA o visado",
				text: "Con pasaporte español necesitas ETA (se pide online). Si tu pasaporte es de otro país, revisa si necesitas ETA o visado.",
			},
			{
				icon: "ticket",
				title: "Reserva lo que se agota",
				text: "El Castillo de Edimburgo, Mary King’s Close, algunos tours de fantasmas y las excursiones a las Highlands pueden agotarse, especialmente en temporada alta. Reserva con antelación.",
			},
			{
				icon: "tip",
				title: "Propina y libras",
				text: "La moneda es la libra esterlina (£). La propina no es obligatoria, en restaurantes es habitual dejar alrededor de un 10% si el servicio no está ya incluido en la cuenta.",
			},
			{
				icon: "hotel",
				title: "Dónde dormir",
				text: "Old Town si quieres estar junto a la Royal Mile y el ambiente histórico. New Town si prefieres una zona más tranquila y con menos cuestas.",
			},
			{
				icon: "plug",
				title: "Enchufe tipo G",
				text: "Si vienes de Europa, necesitarás adaptador. El enchufe británico es de tipo G.",
			},
			{
				icon: "card",
				title: "Contactless en bus y tram",
				text: "En Edimburgo no hay metro. En los Lothian Buses puedes pagar con tarjeta o móvil al subir.",
			},
		],
		neighborhoodsTitle: "Las principales zonas",
		neighborhoods: [
			{
				name: "Old Town",
				text: "El corazón histórico de Edimburgo. Aquí están el Castillo, la Royal Mile, Victoria Street, Grassmarket y muchos de los famosos closes.",
			},
			{
				name: "Holyrood y Arthur’s Seat",
				text: "Al final de la Royal Mile encontrarás el Palace of Holyroodhouse, las ruinas de Holyrood Abbey y Holyrood Park, donde se encuentra Arthur’s Seat.",
			},
			{
				name: "New Town + Calton Hill",
				text: "La parte georgiana de Edimburgo: Princes Street, George Street o Rose Street. Muy cerca está Calton Hill, uno de los mejores puntos para ver la ciudad desde arriba.",
			},
			{
				name: "Dean Village y Stockbridge",
				text: "Una de las zonas más bonitas para pasear con calma. Dean Village parece un pequeño pueblo junto al río y desde allí puedes seguir el Water of Leith hasta Stockbridge.",
			},
		],
		gettingAround: {
			title: "Cómo moverse",
			items: [
				{
					icon: "direction",
					title: "A pie por el centro",
					text: "Edimburgo se recorre muy bien caminando. Old Town, New Town, Calton Hill y Dean Village quedan a una distancia razonable si te alojas en el centro.",
				},
				{
					icon: "transit",
					title: "Bus y tranvía",
					text: "No hay metro. Los Lothian Buses cubren prácticamente toda la ciudad y el tranvía conecta el aeropuerto, el centro y Leith. Para una ruta de 3 días probablemente usarás poco el transporte si te alojas en el centro.",
				},
				{
					icon: "card",
					title: "Paga con contactless",
					text: "Puedes pagar directamente con tarjeta o móvil. En los buses normales solo tienes que acercar la tarjeta al subir; en el tranvía debes hacer tap on antes de subir y tap off al bajar. Usando siempre la misma tarjeta o dispositivo, el sistema aplica límites diarios y semanales automáticamente.",
				},
				{
					icon: "airport",
					title: "Desde el aeropuerto",
					text: "El tranvía conecta el aeropuerto con el centro y continúa hasta Newhaven, pasando por Princes Street y St Andrew Square. Otra opción es el Airlink 100, que funciona las 24 horas y conecta el aeropuerto con el centro.",
				},
			],
		},
		itineraryTitle: "Itinerario de 3 días de la guía",
		itineraryPreview: [
			{
				day: 1,
				title: "Old Town, castillo y Royal Mile",
			},
			{
				day: 2,
				title: "De Holyrood a Calton Hill",
			},
			{
				day: 3,
				title: "New Town, Dean Village y Stockbridge",
			},
		],
		hub: [
			{
				title: "Ver la guía",
				text: "Descubre la ruta con los días organizados, lugares imprescindibles y toda la información para preparar tu viaje.",
				to: "/preview/prebuilt/edimburgo",
				icon: "preview",
			},
			{
				title: "Organiza tu ruta",
				text: "Crea tu recorrido por Edimburgo y elige los lugares que quieres visitar.",
				to: "/crear-ruta",
				icon: "route",
			},
			{
				title: "Álbum de viaje",
				text: "Guarda tus recuerdos de Edimburgo con páginas de scrapbook y stickers.",
				to: "/album",
				icon: "album",
			},
		],
		spots: [
			{
				icon: "map",
				title: "Ruta día a día",
				text: "Tres días por capas, más un extra para las Highlands.",
			},
			{
				icon: "museum",
				title: "Castillo y palacio",
				text: "Edinburgh Castle, Holyroodhouse y el Museo Nacional.",
			},
			{
				icon: "transit",
				title: "Buses, tram y EDI",
				text: "Sin metro: contactless, Lothian Buses y el tram al aeropuerto.",
			},
			{
				icon: "sparkle",
				title: "Tips para el viaje",
				text: "ETA, impermeable, midges y lo que sí hay que reservar.",
			},
			{
				icon: "nightlife",
				title: "Fantasmas y pubs",
				text: "Vaults de noche, Greyfriars y un dram sin trampa.",
			},
			{
				icon: "store",
				title: "Comida y mercados",
				text: "Haggis, Cullen skink, Stockbridge y el market del sábado.",
			},
		],
		related: ["londres", "paris", "belgica"],
	},
};

const SLUG_ALIASES = {
	seoul: "seul",
	kyoto: "kioto",
	tokyo: "tokio",
	ny: "nueva-york",
	"new-york": "nueva-york",
	sanfrancisco: "san-francisco",
	kl: "kuala-lumpur",
	beijing: "pekin",
	edinburgh: "edimburgo",
};

export const GUIDE_ID_TO_SLUG = Object.fromEntries(
	Object.values(GUIDE_LANDINGS).map((landing) => [
		landing.guideId,
		landing.slug,
	]),
);

export function getLandingBySlug(slug) {
	if (!slug) return null;
	const key = SLUG_ALIASES[slug] || slug;
	return GUIDE_LANDINGS[key] || null;
}

export function guideLandingPath(guideId) {
	const slug = GUIDE_ID_TO_SLUG[guideId];
	return slug ? `/${slug}` : null;
}

/** Landing si existe; si no (Travel Kit, etc.) la preview de siempre. */
export function guideEntryPath(guideId) {
	return guideLandingPath(guideId) || `/preview/prebuilt/${guideId}`;
}

export function listLandingSlugs() {
	return Object.keys(GUIDE_LANDINGS);
}
